import jwtAuthAxios from "../../../services/jwtAuth";
import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';

export const getKalenderAkademikAll = createAsyncThunk("kalenderAkademik/getAll", 
    async({page = 1, size = 3, sort='periodeId~asc'}) => {
        try{
            let token = await localStorage.getItem('auth_token');
            jwtAuthAxios.defaults.headers.common['Authorization'] = 'Bearer ' + token;
            const response = await jwtAuthAxios.get(`v1/kalender-akademik/pageable?page=${page}&size=${size}&sort=${sort}`)
            return response.data.data.result
        } catch(response){
            throw response
        }
    }
);

export const getByKalenderAkademikByPeriodeId = createAsyncThunk("kalenderAkademik/getByKalenderAkademikByPeriodeId", 
async(periodeId) => {
    try{
        let token = await localStorage.getItem('auth_token');
        jwtAuthAxios.defaults.headers.common['Authorization'] = 'Bearer ' + token;
        const url = `v1/kalender-akademik/${periodeId}`
        const response = await jwtAuthAxios.get(url)
        return response.data
    } catch(response){
        throw response
    }
});

export const findAllKalenderAkademik = createAsyncThunk("eventAkademik/findAllKalenderAkademik",
    async(val) => {
        try{
            let token = await localStorage.getItem('auth_token');
            jwtAuthAxios.defaults.headers.common['Authorization'] = 'Bearer ' + token;
            const url = `v1/kalender-akademik`
            const response = await jwtAuthAxios.get(url)
            return response.data;
        } catch(response){
            throw response
        }
    });

export const findByPeriodeIdKalenderAkademik = createAsyncThunk("eventAkademik/findByPeriodeIdKalenderAkademik",
    async(val) => {
        try{
            let token = await localStorage.getItem('auth_token');
            jwtAuthAxios.defaults.headers.common['Authorization'] = 'Bearer ' + token;
            const url = `v1/kalender-akademik/periode/${val}`
            const response = await jwtAuthAxios.get(url)
            return response.data;
        } catch(response){
            throw response
        }
    });
export const findByIdKalenderAkademik = createAsyncThunk("eventAkademik/findByIdKalenderAkademik",
    async(val) => {
        try{
            let token = await localStorage.getItem('auth_token');
            jwtAuthAxios.defaults.headers.common['Authorization'] = 'Bearer ' + token;
            const url = `v1/kalender-akademik/${val}`
            const response = await jwtAuthAxios.get(url,val)
            return response.data;
        } catch(response){
            throw response
        }
    });
export const saveKalenderAkademik = createAsyncThunk("eventAkademik/saveKalenderAkademik",
    async(val) => {
        try{
            let token = await localStorage.getItem('auth_token');
            jwtAuthAxios.defaults.headers.common['Authorization'] = 'Bearer ' + token;
            const url = `v1/kalender-akademik`
            const response = await jwtAuthAxios.post(url,val)
            return response.data;
        } catch(response){
            throw response
        }
    });
export const updateKalenderAkademik = createAsyncThunk("eventAkademik/updateKalenderAkademik",
    async(val) => {
        try{
            let token = await localStorage.getItem('auth_token');
            jwtAuthAxios.defaults.headers.common['Authorization'] = 'Bearer ' + token;
            const url = `v1/kalender-akademik`
            const response = await jwtAuthAxios.put(url,val)
            return response.data;
        } catch(response){
            throw response
        }
    });
export const deleteKalenderAkademik = createAsyncThunk("eventAkademik/deleteKalenderAkademik",
    async(val) => {
        try{
            let token = await localStorage.getItem('auth_token');
            jwtAuthAxios.defaults.headers.common['Authorization'] = 'Bearer ' + token;
            const url = `v1/kalender-akademik/${val}`
            const response = await jwtAuthAxios.delete(url)
            return response.data;
        } catch(response){
            throw response
        }
    });

const initialState = {
    loading: false,
    loadingKa: false,
    dataListKa: [],
    dataKa: {},
    dataAllKalenderAkademik: [],
    dataKurikulumAkademikPeriode: []
}

const kalenderAkademikSlice = createSlice({
    name:"kalenderAkademik",
    initialState: initialState,
    extraReducers: (builder) => {
    builder
        .addCase(getKalenderAkademikAll.pending, (state) => {
            state.loading = true;
        })
        .addCase(getKalenderAkademikAll.fulfilled, (state, action) => {
            state.dataAllKalenderAkademik = action.payload;
            state.loading = false;
        })
        .addCase(getKalenderAkademikAll.rejected, (state, action) => {
            state.loading = false;
        })
    builder
        .addCase(getByKalenderAkademikByPeriodeId.pending, (state) => {
            state.loading = true;
        })
        .addCase(getByKalenderAkademikByPeriodeId.fulfilled, (state, action) => {
            state.dataKurikulumAkademikPeriode = action.payload;
            state.loading = false;
        })
        .addCase(getByKalenderAkademikByPeriodeId.rejected, (state, action) => {
            state.loading = false;
        })
    builder
        .addCase(findAllKalenderAkademik.pending, (state) => {
            state.loadingKa = true;
        })
        .addCase(findAllKalenderAkademik.fulfilled, (state, action) => {
            state.dataListKa = action.payload;
            state.loadingKa = false;
        })
        .addCase(findAllKalenderAkademik.rejected, (state, action) => {
            state.loadingKa = false;
        })
    builder
        .addCase(findByPeriodeIdKalenderAkademik.pending, (state) => {
            state.loadingKa = true;
        })
        .addCase(findByPeriodeIdKalenderAkademik.fulfilled, (state, action) => {
            state.dataListKa = action.payload;
            state.loadingKa = false;
        })
        .addCase(findByPeriodeIdKalenderAkademik.rejected, (state, action) => {
            state.loadingKa = false;
        })
    builder
        .addCase(saveKalenderAkademik.pending, (state) => {
            state.loadingKa = true;
        })
        .addCase(saveKalenderAkademik.fulfilled, (state, action) => {
            state.dataKa = action.payload;
            state.loadingKa = false;
        })
        .addCase(saveKalenderAkademik.rejected, (state, action) => {
            state.loadingKa = false;
        })
    builder
        .addCase(updateKalenderAkademik.pending, (state) => {
            state.loadingKa = true;
        })
        .addCase(updateKalenderAkademik.fulfilled, (state, action) => {
            state.dataKa = action.payload;
            state.loadingKa = false;
        })
        .addCase(updateKalenderAkademik.rejected, (state, action) => {
            state.loadingKa = false;
        })
    builder
        .addCase(deleteKalenderAkademik.pending, (state) => {
            state.loadingKa = true;
        })
        .addCase(deleteKalenderAkademik.fulfilled, (state, action) => {
            state.dataKa = action.payload;
            state.loadingKa = false;
        })
        .addCase(deleteKalenderAkademik.rejected, (state, action) => {
            state.loadingKa = false;
        })
    builder
        .addCase(findByIdKalenderAkademik.pending, (state) => {
            state.loadingKa = true;
        })
        .addCase(findByIdKalenderAkademik.fulfilled, (state, action) => {
            state.dataKa = action.payload;
            state.loadingKa = false;
        })
        .addCase(findByIdKalenderAkademik.rejected, (state, action) => {
            state.loadingKa = false;
        })
        
    }
})
export const kalenderAkademikSelector = (state) => state.kalenderAkademik;
export default kalenderAkademikSlice.reducer;